<mat-toolbar color="primary">
  <span>{{pageTitle}}</span>
  <span class="right-align"></span>
  <a routerLink="/sign-in">
    <button mat-raised-button>{{ 'accessPage.enterButton' | translate }}</button>
  </a>
  <a routerLink="/sign-up" class="no-effects">
    <button mat-button>{{ 'accessPage.signUpButton' | translate }}</button>
  </a>
</mat-toolbar>